import script from "./MyStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./MyStepper.vue?vue&type=script&setup=true&lang=js"

import "./MyStepper.vue?vue&type=style&index=0&id=31b7d80c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b7d80c"]])

export default __exports__